import React from "react";
import PropTypes from "prop-types";
import { css } from "@emotion/react";
import { colors, fontSize } from "style";

/**
 * Show a generic error message
 *
 * @params {Element}  children
 * @params {String}   width
 */
const FormFieldError = ({ children, width }) => (
  <div data-error css={style(width)}>
    {children}
  </div>
);

const style = (width) => css`
  font-size: ${fontSize.xxsmall};
  color: ${colors.red};
  font-weight: 400;
  order: 3;
  margin-top: 0.8rem;
  width: ${width};
`;

FormFieldError.propTypes = {
  children: PropTypes.node.isRequired,
  width: PropTypes.string.isRequired,
};

export default FormFieldError;
